/**

 * SEO Configuration File

 * Centralized SEO settings and defaults for the Aptofy website

 */



export const siteConfig = {

  name: "Aptofy",

  url: "https://www.aptofy.com",

  description: "Aptofy is a patented AI hiring platform that cuts carbon emissions by 50–99% while delivering accurate, bias-free, real-time candidate evaluations.",

  defaultImage: "https://www.aptofy.com/assets/aptofy.png",

  twitterHandle: "@aptofy", // Update with actual Twitter handle if available

  facebookAppId: "", // Add if you have Facebook App ID

  locale: "en_US",

};



/**

 * Generate Organization structured data

 */

export const getOrganizationSchema = () => ({

  "@context": "https://schema.org",

  "@type": "Organization",

  name: "Aptofy",

  url: siteConfig.url,

  logo: siteConfig.defaultImage,

  description: siteConfig.description,

  sameAs: [

    // Add your social media profiles here

    // "https://www.linkedin.com/company/aptofy",

    // "https://twitter.com/aptofy",

    // "https://www.facebook.com/aptofy",

  ],

  contactPoint: {

    "@type": "ContactPoint",

    contactType: "Customer Service",

    // Add contact information if available

  },

});



/**

 * Generate WebSite structured data

 */

export const getWebsiteSchema = () => ({

  "@context": "https://schema.org",

  "@type": "WebSite",

  name: siteConfig.name,

  url: siteConfig.url,

  description: siteConfig.description,

  publisher: {

    "@type": "Organization",

    name: siteConfig.name,

  },

});



/**

 * Generate BreadcrumbList structured data

 */

export const getBreadcrumbSchema = (items) => {

  if (!items || items.length === 0) return null;

  

  return {

    "@context": "https://schema.org",

    "@type": "BreadcrumbList",

    itemListElement: items.map((item, index) => ({

      "@type": "ListItem",

      position: index + 1,

      name: item.name,

      item: item.url,

    })),

  };

};



/**

 * Generate Article structured data

 */

export const getArticleSchema = (article) => {

  if (!article) return null;

  

  return {

    "@context": "https://schema.org",

    "@type": "Article",

    headline: article.headline,

    description: article.description,

    image: article.image || siteConfig.defaultImage,

    datePublished: article.datePublished,

    dateModified: article.dateModified || article.datePublished,

    author: {

      "@type": "Organization",

      name: siteConfig.name,

    },

    publisher: {

      "@type": "Organization",

      name: siteConfig.name,

      logo: {

        "@type": "ImageObject",

        url: siteConfig.defaultImage,

      },

    },

  };

};



/**

 * Generate Service structured data

 */

export const getServiceSchema = (service) => {

  if (!service) return null;

  

  return {

    "@context": "https://schema.org",

    "@type": "Service",

    serviceType: service.serviceType || "AI-Powered Recruitment",

    provider: {

      "@type": "Organization",

      name: siteConfig.name,

    },

    areaServed: {

      "@type": "Country",

      name: "India",

    },

    description: service.description,

  };

};



/**

 * Generate FAQPage structured data

 */

export const getFAQSchema = (faqs) => {

  if (!faqs || faqs.length === 0) return null;

  

  return {

    "@context": "https://schema.org",

    "@type": "FAQPage",

    mainEntity: faqs.map((faq) => ({

      "@type": "Question",

      name: faq.question,

      acceptedAnswer: {

        "@type": "Answer",

        text: faq.answer,

      },

    })),

  };

};


